var today = new Date();

export default {
    Emails: [
        {
            From: "Alavian-h",
            Date: "2018/01/22",
            Title: "Reorganize Index Done",
            Avatar: 'assets/images/avatars/7.jpg',
        },
        {
            From: "Alavian-h",
            Date: "2018/01/22",
            Title: "SQL جلسه سوم کلاس آموزش",
            Avatar: 'assets/images/avatars/7.jpg',
        },
        {
            From: "Alavian-h",
            Date: "2018/01/22",
            Title: "ERMS Updated_NGL3100 project_Mechanical department",
            Avatar: 'assets/images/avatars/7.jpg'
        }

    ],
    Tasks: [
        {
            ProjectId: 1,
            ProjectCode: 'EX1441',
            TaskName: 'Received First Process Data Sheet for Compressors from Basic Designer'
        }
    ],

    Homa: {
        CurrentTask: [
            { "UniqueId": "fba19711-f243-491c-8f35-44a0d1281cf7", "RefNo": "EX1533-T-HV/PM-0069", "Type": "Ext. Draft Accept By EngMng", "ProjectName": "EX1533", "From": " ", "ReceivedDate": "2019/01/01 8:30", "DueDate": "2019/01/01 8:30", "DoDate": "2019/01/05 8:30", "Description": null, "VendorName": null, "AppCode": "External_CheckByDcc", "ToUserId": 108, "ToRoleId": 4, "JobType": 0, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "fba19711-f243-491c-8f35-44a0d1281cf8", "RefNo": "EX1533-T-HV/PM-0069", "Type": "Ext. Draft Accept By EngMng", "ProjectName": "EX1533", "From": " ", "ReceivedDate": "2019/01/01 8:30", "DueDate": "2019/01/01 8:30", "DoDate": "2019/01/05 8:30", "Description": null, "VendorName": null, "AppCode": "External_CheckByDcc", "ToUserId": 108, "ToRoleId": 4, "JobType": 0, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "fba19711-f243-491c-8f35-44a0d1281cf9", "RefNo": "EX1533-T-HV/PM-0069", "Type": "Ext. Draft Accept By EngMng", "ProjectName": "EX1533", "From": " ", "ReceivedDate": "2019/01/01 8:30", "DueDate": "2019/01/01 8:30", "DoDate": "2019/01/05 8:30", "Description": null, "VendorName": null, "AppCode": "External_CheckByDcc", "ToUserId": 108, "ToRoleId": 4, "JobType": 0, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "fba19711-f243-491c-8f35-44a0d1281cf1", "RefNo": "EX1533-T-HV/PM-0069", "Type": "Ext. Draft Accept By EngMng", "ProjectName": "EX1533", "From": " ", "ReceivedDate": "2019/01/01 8:30", "DueDate": "2019/01/01 8:30", "DoDate": "2019/01/05 8:30", "Description": null, "VendorName": null, "AppCode": "External_CheckByDcc", "ToUserId": 108, "ToRoleId": 4, "JobType": 0, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "fba19711-f243-491c-8f35-44a0d1281cf2", "RefNo": "EX1533-T-HV/PM-0069", "Type": "Ext. Draft Accept By EngMng", "ProjectName": "EX1533", "From": " ", "ReceivedDate": "2019/01/01 8:30", "DueDate": "2019/01/01 8:30", "DoDate": "2019/01/05 8:30", "Description": null, "VendorName": null, "AppCode": "External_CheckByDcc", "ToUserId": 108, "ToRoleId": 4, "JobType": 0, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null }
        ],
        DoneTask: [
            { "UniqueId": "d91d0e80-ea7d-4502-819a-712bba61c678", "RefNo": "EX1533-T-EL/PM-0205", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "f036e704-6da8-40c9-a47a-91e941662411", "RefNo": "EX1533-T-ME/PM-0149", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "60c4f806-5eef-401d-b671-c48169573b0b", "RefNo": "EX1533-T-PI/PM-0133", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "be2d8a32-7677-4c64-a90d-f1c14c6e5aba", "RefNo": "EX1533-T-EL/PM-0206", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "5e15cc51-52c8-4813-90ca-afce075c0aae", "RefNo": "EX1533-T-PR/PM-0386", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "538aa8b7-b4cf-42f8-90c1-58832159bcb5", "RefNo": "KHYCO-EH/PH-T-1568", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "7327e304-f1e2-4f33-bae6-89befa747cfd", "RefNo": "KHYCO-EH/PH-T-1566", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "0c97da7b-b7ba-4367-9273-840510707435", "RefNo": "KHYCO-EH/PH-T-1565", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "d52f7c15-63c9-4a85-94c5-a1801da83783", "RefNo": "KHYCO-EH/PH-T-1564", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "8eb58707-e939-4a82-9dcb-fb0ecab47371", "RefNo": "KHYCO-EH/PH-T-1563", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null }
        ],
        MessageTask: [
            { "UniqueId": "d91d0e80-ea7d-4502-819a-712bba61c678", "RefNo": "EX1533-T-EL/PM-0205", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "f036e704-6da8-40c9-a47a-91e941662411", "RefNo": "EX1533-T-ME/PM-0149", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "60c4f806-5eef-401d-b671-c48169573b0b", "RefNo": "EX1533-T-PI/PM-0133", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "be2d8a32-7677-4c64-a90d-f1c14c6e5aba", "RefNo": "EX1533-T-EL/PM-0206", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "5e15cc51-52c8-4813-90ca-afce075c0aae", "RefNo": "EX1533-T-PR/PM-0386", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "538aa8b7-b4cf-42f8-90c1-58832159bcb5", "RefNo": "KHYCO-EH/PH-T-1568", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "7327e304-f1e2-4f33-bae6-89befa747cfd", "RefNo": "KHYCO-EH/PH-T-1566", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "0c97da7b-b7ba-4367-9273-840510707435", "RefNo": "KHYCO-EH/PH-T-1565", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "d52f7c15-63c9-4a85-94c5-a1801da83783", "RefNo": "KHYCO-EH/PH-T-1564", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "8eb58707-e939-4a82-9dcb-fb0ecab47371", "RefNo": "KHYCO-EH/PH-T-1563", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null }
        ],
        OverDueTask: [
            { "UniqueId": "d91d0e80-ea7d-4502-819a-712bba61c678", "RefNo": "EX1533-T-EL/PM-0205", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "f036e704-6da8-40c9-a47a-91e941662411", "RefNo": "EX1533-T-ME/PM-0149", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "60c4f806-5eef-401d-b671-c48169573b0b", "RefNo": "EX1533-T-PI/PM-0133", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "be2d8a32-7677-4c64-a90d-f1c14c6e5aba", "RefNo": "EX1533-T-EL/PM-0206", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "5e15cc51-52c8-4813-90ca-afce075c0aae", "RefNo": "EX1533-T-PR/PM-0386", "Type": "Ext. Draft Ready For Issue", "ProjectName": "EX1533", "From": "Ali  Mehrabian", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_Final", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 3, "Discipline": false, "Code": null },
            { "UniqueId": "538aa8b7-b4cf-42f8-90c1-58832159bcb5", "RefNo": "KHYCO-EH/PH-T-1568", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "7327e304-f1e2-4f33-bae6-89befa747cfd", "RefNo": "KHYCO-EH/PH-T-1566", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "0c97da7b-b7ba-4367-9273-840510707435", "RefNo": "KHYCO-EH/PH-T-1565", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "d52f7c15-63c9-4a85-94c5-a1801da83783", "RefNo": "KHYCO-EH/PH-T-1564", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null },
            { "UniqueId": "8eb58707-e939-4a82-9dcb-fb0ecab47371", "RefNo": "KHYCO-EH/PH-T-1563", "Type": "Ext. Issued Transmittal Recieved by Owner", "ProjectName": "EX1533", "From": "PIDMCO", "ReceivedDate": "2012/02/01 12:45", "DueDate": "2012/02/01 12:45", "DoDate": "2012/02/10 12:45", "Description": null, "VendorName": null, "AppCode": "External_ViewTransmittal", "ToUserId": 108, "ToRoleId": 4, "JobType": 1, "Done": false, "Archived": false, "IsActive": true, "Viewed": false, "TaskTypeId": 15, "Discipline": false, "Code": null }
        ]
    },

    HeaderItems: [
        // {
        //     Name: 'داشبورد',
        //     Url: '/Dashboard',
        //     Icon: 'fa fa-setting',
        //     visible: true
        // },
        // {
        //     Name: 'تنظیمات',
        //     Url: '/Setting',
        //     Icon: 'icon-settings',
        //     visible: true
        // },
        // {
        //     Name: 'گالری',
        //     Url: '/Gallary',
        //     Icon: 'fa fa-image',
        //     visible: true
        // }

    ],

    items: [
        {
            name: 'صفحه اصلی',
            url: '/',
            icon: 'fa fa-home',
            visible: true,
            //To prevent remove from final menu list, assign applicationComponentId a number less than 0.
            applicationComponentId: -1,
            children: []
        },
        {
            name: 'درباره EIED',
            url: '/About',
            icon: 'icon-info',
            visible: true,
            children: [
                {
                    name: 'مقدمه',
                    url: '/About/Introduction',
                    icon: 'icon-info',
                    applicationComponentId: 28,
                    visible: true
                },
                {
                    name: 'پروفایل شرکت',
                    url: '/About/Profile',
                    icon: 'icon-info',
                    applicationComponentId: 29,
                    visible: true,
                    children: [
                        {
                            name: 'کاتالوگ انگلیسی',
                            url: '/About/Profile/EiedEnglishCatalog',
                            icon: 'icon-info',
                            applicationComponentId: 137,
                            visible: true,
                        },
                        {
                            name: 'کاتالوگ فارسی',
                            url: '/About/Profile/EiedPersianCatalog',
                            icon: 'icon-info',
                            applicationComponentId: 138,
                            visible: true,
                        },
                        {
                            name: 'پروفایل شرکت',
                            url: '/About/Profile/CompanyProfile',
                            icon: 'icon-info',
                            applicationComponentId: 139,
                            visible: true,
                        },
                        {
                            name: 'معرفی نامه شرکت',
                            url: '/About/Profile/CompanyReference',
                            icon: 'icon-info',
                            applicationComponentId: 140,
                            visible: true,
                        }

                    ]
                },
                {
                    name: 'گواهینامه ها',
                    url: '/About/Iso',
                    icon: 'icon-info',
                    applicationComponentId: 64,
                    visible: true
                },
                {
                    name: 'خط مشی کیفیت',
                    url: '/About/Policy',
                    icon: 'icon-info',
                    applicationComponentId: 65,
                    visible: true
                },
                {
                    name: 'خط مشی بهداشت، ایمنی و محیط زیست',
                    url: '/About/SafetyPolicy',
                    icon: 'icon-info',
                    applicationComponentId: 66,
                    visible: true
                },
                {
                    name: 'بیانیه چشم انداز و ماموریت',
                    url: '/About/MissionVision',
                    icon: 'icon-info',
                    applicationComponentId: 67,
                    visible: true
                },
                {
                    name: 'بیانیه ارزشها',
                    url: '/About/DeclarationValue',
                    icon: 'icon-info',
                    applicationComponentId: 69,
                    visible: true
                },
                {
                    name: 'نمودار فرایندهای کلیدی',
                    url: '/About/KeyProcess',
                    icon: 'icon-info',
                    applicationComponentId: 70,
                    visible: true
                },
                {
                    name: 'منشور اخلاقی و همکاری',
                    url: '/About/MoralCooperationCharter',
                    icon: 'icon-info',
                    applicationComponentId: 71,
                    visible: true
                },
                {
                    name: 'مدیریت درباره EIED',
                    url: '/About/AboutManagement',
                    icon: 'icon-info',
                    applicationComponentId: 145,
                    visible: true
                },                
                // {
                //     name: 'گواهینامه ها',
                //     url: '/About/Iso',
                //     icon: 'fa fa-circle',
                // },
                // {
                //     name: 'گواهینامه ها',
                //     url: '/About/Iso',
                //     icon: 'fa fa-circle',
                // }

            ]
        },
        {
            name: 'مدیریتی',
            url: '/Manager',
            icon: 'icon-star',
            visible: false,
            children: [
                {
                    name: 'گزارش ها',
                    url: '/Manager/Reports',
                    icon: 'icon-star',
                    visible: false,
                    children: [
                        {
                            name: 'گزارش های تایم شیت',
                            url: '/Manager/Reports/TimeSheetReports',
                            icon: 'icon-star',
                            visible: true,
                            children: [
                                {
                                    name: 'نفر ساعت مصرفی بخش ها',
                                    url: '/Manager/Reports/TimeSheetReports/ManhourSectionsConsumptionReport',
                                    icon: 'icon-star',
                                    applicationComponentId: 49,
                                    visible: true,
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'تایید تایم شیت',
                    url: '/TimesheetConfirmation/TimesheetConfirmationContainer',
                    icon: 'icon-star',
                    applicationComponentId: 75,
                    visible: true               
                },
                {
                    name: 'تایید رزومه',
                    url: '/ResumeConfirmation/ResumeConfirmationContainer',
                    icon: 'icon-star',
                    applicationComponentId: 126,
                    visible: true               
                }                
            ],
        },
        {
            name: 'عمومی',
            url: '/Public',
            icon: 'fa fa-users',
            visible: true,
            children: [
                // {
                //     name: 'زمانبندی',
                //     url: '/Schedule',
                //     icon: 'fa fa-circle',
                //     applicationComponentId: 30,
                //     visible: true
                // },
                {
                    name: 'تابلو اعلانات',
                    url: '/InfoBoard',
                    icon: 'fa fa-users',
                    applicationComponentId: 31,
                    visible: true
                },
                {
                    name: 'سالن های جلسات',
                    url: '/Public/ConferenceRooms',
                    icon: 'fa fa-users',
                    applicationComponentId: 38,
                    visible: true
                },
                {
                    name: 'گفتگو',
                    url: '/Public/Chat/all',
                    icon: 'fa fa-users',
                    applicationComponentId: 32,
                    visible: true
                },
                {
                    name: 'فرم های رایج',
                    url: '/FrameContainer/General/Projects/GeneralForms/Forms.aspx/فرم های رایج',
                    icon: 'fa fa-users',
                    // applicationComponentId: 32,
                    visible: true
                },
                {
                    name: 'مدارک QHSE',
                    url: '/FrameContainer/QHSE/DocumentSystem/index.aspx/مدارک QHSE',
                    icon: 'fa fa-users',
                    // applicationComponentId: 32,
                    visible: true
                },
                {
                    name: 'ثبت آدرس',
                    url: '/Public/AddressRegistration',
                    icon: 'fa fa-users',
                    applicationComponentId: 76,
                    visible: true
                },
                {
                    name: 'تردد پرسنل',
                    url: '/Public/PersonnelCommute',
                    icon: 'fa fa-users',
                    applicationComponentId: 76,
                    visible: true
                },
                {
                    name: 'رزرو باشگاه ورزشی',
                    url: '/Public/SportClubReservation',
                    icon: 'fa fa-users',
                    applicationComponentId: 129,
                    visible: true
                }

                // {
                //     name: 'مدیریت تایم شیت',
                //     // url: '',
                //     icon: 'far fa-tasks',
                //     visible: true,
                //     children: [
                //         {
                //             name: 'ثبت و ویرایش تایم شیت',
                //             url: '/Public/Timesheet',
                //             icon: 'fad fa-edit',
                //             applicationComponentId: 37,
                //             visible: true,
                //         },
                //         {
                //             name: 'گزارشات تایم شیت',
                //             url: '/Public/Timesheet/TimesheetReports',
                //             icon: 'fad fa-file-spreadsheet',
                //             applicationComponentId: 55,
                //             visible: true
                //         }
                //     ]
                // },
            ]
        },
        {
            name: 'مدیریت مدارک QHSE',
            url: '/Management/QHSE/DocumentsManagement',
            icon: 'fas fa-layer-group',
            applicationComponentId: 91,
            visible: true
        }, 
        {
            name: 'تنظیمات سیستم ها',
            url: '/SystemConfiguration',
            icon: 'fa fa-cog',
            visible: true,
            children: [
                {
                    name: 'تلفن های داخلی',
                    url: '/SystemConfiguration/Telephons',
                    icon: 'fa fa-cog',
                    applicationComponentId: 33,
                    visible: true
                },
                {
                    name: 'تایید عکس پرسنل',
                    url: '/SystemConfiguration/PhotoConfirmation',
                    icon: 'fa fa-cog',
                    applicationComponentId: 83,
                    visible: true
                },
                {
                    name: 'ثبت لیست غذا',
                    url: '/My/Meal',
                    icon: 'fa fa-cog',
                    applicationComponentId: 34,
                    visible: true
                },
                {
                    name: 'مدیریت تابلو اعلانات',
                    url: '/Management/InfoBoardManagementContainer',
                    icon: 'fa fa-cog',
                    applicationComponentId: 57,
                    visible: true
                },
                {
                    name: 'مدیریت اخبار داخلی',
                    url: '/Management/DomesticNewsManagementContainer',
                    icon: 'fa fa-cog',
                    applicationComponentId: 84,
                    visible: true
                },
                {
                    name: 'بن رفاهی',
                    url: '/Management/ChipFacility',
                    icon: 'fa fa-cog',
                    applicationComponentId: 90,
                    visible: true
                },                                
                {
                    name: 'مدیریت مراکز هزینه',
                    // url: '/Management/CostCenterManagement/',
                    icon: 'fa fa-cog',
                    applicationComponentId: 109,
                    visible: true,
                    children: [
                        {
                            name: 'عملیات مراکز هزینه',
                            url: '/Management/CostCenterManagement/CostCenterOperationContainer',
                            icon: 'fa fa-cog',
                            applicationComponentId: 109,
                            visible: true,
                        },
                        // {
                        //     name: 'عملیات فعالیت ها',
                        //     url: '/Management/CostCenterManagement/ActivityOperation/All',
                        //     icon: 'fa fa-cogs',
                        //     applicationComponentId: 49,
                        //     visible: true,
                        // },
                    ]
    
                },               
                {
                    name: 'مدیریت کافی شاپ',
                    icon: 'fa fa-cog',
                    visible: true,
                    children: [
                        {
                            name: 'دسته بندی خوراکی ها',
                            url: '/Management/CoffeeShop/EdibleCategory',
                            icon: 'fa fa-cog',
                            applicationComponentId: 80,
                            visible: true,
                        },
                        {
                            name: 'منوی سفارشات',
                            url: '/Management/CoffeeShop/MenuModification',
                            icon: 'fa fa-cog',
                            applicationComponentId: 80,
                            visible: true,
                        }

                    ]
    
                },               
                // {
                //     name: 'عدم دسترسی',
                //     url: '/AccessDeneid',
                //     icon: 'fa fa-circle',
                //     applicationComponentId: 59,
                //     visible: true
                // }
            ]
        },
        {
            name: 'گزارش ها',
            url: '/Report',
            icon: 'fa fa-file-pdf',
            visible: true,
            children: [
                {
                    name: 'مدیریت منابع',
                    url: '/Report/Erms',
                    icon: 'fa fa-file-pdf',
                    applicationComponentId: 53,
                },
                {
                    name: 'پرسنل حاضر در شرکت',
                    url: '/Report/QHSE/PresentStaff',
                    icon: 'fa fa-file-pdf',
                    applicationComponentId: 108,
                },
                {
                    name: 'گزارشات کنترل پروژه',
                    url: '/Report/ProjectControls/Dashboards',
                    icon: 'fa fa-file-pdf',
                    applicationComponentId: 146,
                }                                  
              
            ] 
        },
        {
            name: 'پروژه ها',
            url: '/Project',
            icon: 'fa fa-industry',
            visible: true,
            //To prevent remove from final menu list, assign applicationComponentId a number less than 0.
            applicationComponentId: -1,
            children: []
        },
        {
            name: 'شبکه',
            url: '/Network',
            icon: 'fa fa-signal',
            children: [
                {
                    name: 'درایوهای شبکه',
                    url: '/Network/Drives',
                    icon: 'fa fa-signal',
                    applicationComponentId: 128,
                }              
            ] 
        },              
        // {
        //     name: 'داشبورد',
        //     url: '/Dashboard',
        //     icon: 'icon-star',
        // },
        // {
        //     name: 'ERMS',
        //     url: '/ERMSTempForm',
        //     icon: 'icon-star',
        // },
        // {
        //     name: 'ERMS1',
        //     url: '/ERMSTempForm1',
        //     icon: 'icon-star',
        // },
        // {
        //     name: 'GraphQL Test',
        //     url: '/GraphQL',
        //     icon: 'icon-star',
        // }

    ],

    GeneralIdentification: {
        user: {
            firstName: "حمیدرضا",
            lastName: "علویان",
            startDate: "1394/10/19",
            personnelCode: "5631",
            address: "بخش اول آدرس، بخش دوم آدرس، بخش سوم آدرس، کوچه سوم، پلاک 4",
            email: "alavian-h@eied.com",
            tel: "5829",
            birthDate: "نهم / آدز / 1362",
            gender: "Male",
            maritalStatus: "متاهل",
            nationality: "ایرانی",
            totalExperience: "14",
            presenrPosition: "Senior member of staff",
            firstLanguage: "لاتین",
            insuranceStatus: "دارای بیمه تکمیلی دانا با خدمات دندانپزشکی",
            // dependantNumber: "1 نفر",
            requestSummary: {
                totalRequest: 950,
                inProgress: 15,
                done: 935
            },
            dependant: [
                { name: "Rozi", sureName: "Future", nationalCode: "Future", gender: "Femail", birthDate: "" },
                { name: "Suzy", sureName: "Jason", nationalCode: "Jason", gender: "Femail", birthDate: "" },
                { name: "Tom", sureName: "Hannks", nationalCode: "Male", gender: "", birthDate: "" }
            ],
            relation: [
                {
                    name: "نام 1",
                    sureName: "نام خانوادگی 1",
                    nationalId: "0112222222",
                    relationName: "نسبت 1"
                },
                {
                    name: "نام 2",
                    sureName: "نام خانوادگی 2",
                    nationalId: "0222222222",
                    relationName: "نسبت 2"
                },
                {
                    name: "نام 3",
                    sureName: "نام خانوادگی 3",
                    nationalId: "0332222222",
                    relationName: "نسبت 3"
                },
                {
                    name: "نام 4",
                    sureName: "نام خانوادگی 4",
                    nationalId: "0442222222",
                    relationName: "نسبت 4"
                },

            ],
            resume: {
                language: [
                    { name: "English" }, { name: "Spanish" }, { name: "Japanese" }
                ],
                education: [
                    {
                        degree: "PhD", subject: "Computer Software", university: "Massachusetts Institute of Technology (MIT)",
                        dateFrom: "10 April 2015", dateTo: "Present"
                    },
                    {
                        degree: "M.S.", subject: "Computer Software", university: "Harvard University",
                        dateFrom: "25 March 2013", dateTo: "10 April 2015"
                    },
                    {
                        degree: "BS", subject: "Computer Software", university: "Azad University",
                        dateFrom: "22 July 2009", dateTo: "25 March 2013"
                    },
                    {
                        degree: "Diploma", subject: "Computer Software", university: "Unknown Complex",
                        dateFrom: "20 Sep 2002", dateTo: "22 July 2009"
                    }
                ],
                skills: [
                    { name: "C#" },
                    { name: "Dot net MVC" },
                    { name: "Dot net Core 2" },
                    { name: "SqlServer" },
                    { name: "StoreProcedure" },
                    { name: "EntityFramework 6" },
                    { name: "EntityFramework Core" },
                    { name: "CodeFirst" },
                    { name: "Asp.net Identity" },
                    { name: "Migration" },
                    { name: "Linq" },
                    { name: "Bootstrap 3" },
                    { name: "CSS 3" },
                    { name: "HTML 5" },
                    { name: "JQuery" },
                    { name: "JavaScript" },
                    { name: "Restfull" },
                    { name: "Swap" },
                    { name: "IIFE" },
                    { name: "DiferPromise" },
                    { name: "KendoUi" },
                    { name: "Angular js" },
                    { name: "Signal R" },
                    { name: "Q js" },
                    { name: "Require js" },
                    { name: "Java Jee" },
                    { name: "EJB" },
                    { name: "JPA" },
                    { name: "JDBC" },
                    { name: "GlassFish" },
                    { name: "Android" },
                    { name: "NFC" },
                    { name: "FCM" },
                    { name: "GoogleAPI" },
                    { name: "Sqlite" },
                    { name: "RealmDB" },
                    { name: "Git" },
                    { name: "TFS" },
                    { name: "Retrofit" },
                    { name: "Dagger 2" },
                    { name: "MVP" },
                    { name: "MVVM" },
                    { name: "Knockout js" },
                    { name: "Unit Of Work" },
                    { name: "Swagger" },
                    { name: "JWT" },
                    { name: "IoC" },
                    { name: "DI" },
                    { name: "Unity For DI" },
                    { name: "AutoMapper" },
                    { name: "Angular 7" },
                    { name: "RX js" },
                    { name: "TypeScript" },
                    { name: "Ninject" },
                    { name: "MongoDB" },
                    { name: "Swift 4 (Junior)" }
                ],
                training: [
                    { date: "1996-09-10 00:00:00.000", name: "Informix DataBase", company: "Marlic Computer CO.", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "40" },
                    { date: "1996-11-01 00:00:00.000", name: "Unix OS", company: "Marlic Computer CO.", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "30" },
                    { date: "2005-06-01 00:00:00.000", name: "SQL Server 2005", company: "EIED", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "60" },
                    { date: "2006-04-01 00:00:00.000", name: "Replicate DataBase Sql Server 2005", company: "EIED", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "12" },
                    { date: "2006-04-07 00:00:00.000", name: "ISO:9001-2000", company: "EIED", country: "Iran", "specialGeneral": "2", certificate: "false", totalHours: "4" },
                    { date: "2008-11-01 00:00:00.000", name: "UML", company: "EIED", country: "Iran", "specialGeneral": "1", certificate: "true", totalHours: "40" },
                    { date: "2004-09-05 00:00:00.000", name: "vb .net 2003", company: "EIED", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "50" },
                    { date: "2011-10-01 00:00:00.000", name: " Share Point 2010", company: "Marlic Computer CO.", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "20" },
                    { date: "2014-03-01 00:00:00.000", name: "work flow", company: "EIED", country: "Iran", "specialGeneral": "1", certificate: "false", totalHours: "20" },
                    { date: "2015-04-26 00:00:00.000", name: "Risk Managment", company: "EIED", country: "Iran", "specialGeneral": "2", certificate: "true", totalHours: "8" }
                ],
                experience: [
                    { fromDate: "2016-09-24 00:00:00.000", toDate: "1997-08-24 00:00:00.000", company: "Andishe Negar - 1 Co", project: "Financial System in Tehran's municipal", position: "Programmer", city: "Tehran", remark: "" },
                    { fromDate: "2015-08-25 00:00:00.000", toDate: "1998-07-25 00:00:00.000", company: "Andishe Negar - 2 Co", project: "Financial System in Tehran's municipal", position: "Programmer", city: "Iran", remark: "" },
                    { fromDate: "2014-07-26 00:00:00.000", toDate: "1999-06-26 00:00:00.000", company: "Andishe Negar - 3 Co", project: "foreign Ministry  Of Iran", position: "Programmer", city: "Tehran", remark: "" },
                    { fromDate: "2012-06-27 00:00:00.000", toDate: "2000-05-27 00:00:00.000", company: "Andishe Negar - 4 Co", project: "Financial System in Tehran's municipal", position: "Programmer", city: "Iran", remark: "" },
                    { fromDate: "2012-05-28 00:00:00.000", toDate: "2001-04-28 00:00:00.000", company: "Andishe Negar - 5 Co", project: "Financial System in Tehran's municipal", position: "Programmer", city: "Tehran", remark: "" },
                    { fromDate: "2011-04-29 00:00:00.000", toDate: "2002-03-29 00:00:00.000", company: "Andishe Negar - 6 Co", project: "Archive System", position: "Programmer", city: "Tehran", remark: "" },
                    { fromDate: "2010-03-30 00:00:00.000", toDate: "2003-02-21 00:00:00.000", company: "Andishe Negar - 7 Co", project: "Financial System in Tehran's municipal", position: "Programmer", city: "Iran", remark: "" },
                    { fromDate: "2019-02-31 00:00:00.000", toDate: "2004-01-22 00:00:00.000", company: "Andishe Negar - 8 Co", project: "Engineering Software", position: "Programmer", city: "Iran", remark: "" },
                    { fromDate: "2018-01-32 00:00:00.000", toDate: "2005-09-23 00:00:00.000", company: "Andishe Negar - 9 Co", project: "Financial System in Tehran's municipal", position: "Programmer", city: "Tehran", remark: "" }
                ],
                membership: [
                    { name: "Membership Group 1" },
                    { name: "Membership Group 2" },
                    { name: "Membership Group 3" },
                    { name: "Membership Group 4" },
                    { name: "Membership Group 5" },
                    { name: "Membership Group 6" },
                    { name: "Membership Group 7" },
                    { name: "Membership Group 8" }
                ],
                publication: [
                    { name: "Publication of Book A" },
                    { name: "Publication of Book B" },
                    { name: "Publication of Book C" },
                    { name: "Publication of Book D" },
                    { name: "Publication of Book E" },
                    { name: "Publication of Book F" },
                    { name: "Publication of Book G" },
                    { name: "Publication of Book H" },
                    { name: "Publication of Book I" },
                ],
            }
        }
    },

    InfoBoard: [
        {
            title: "آگهی مجمع عمومی سالیانه شرکت تعاونی کارکنان",
            date: "1396/05/23",
            owner: "اطلاعات عمومی"
        },
        {
            title: "نقش ویتامین دی در داشتن استخوان بندی سالم چیست",
            date: "1396/06/28",
            owner: "اطلاعات عمومی"
        },
        {
            title: "اطلاعیه ساعت کار شرکت به مناسبت آغاز سال تحصیلی",
            date: "1398/06/31",
            owner: "اداری و پشتیبانی"
        },
        {
            title: "اعلام نتایج قرعه کشی اماکن اقامتی مشهد و مجتمع آهوان چابکسر (فصل پاییز)",
            date: "1398/06/25",
            owner: "اداری و پشتیبانی"
        },
        {
            title: "پیام مدیریت محترم عامل، جناب آقای مهندس غفاریزاده،به مناسبت بیست و سومین سالگرد تاسیس شرکت طراحی و مهندسی صنایع انرژی",
            date: "1398/06/05",
            owner: "روابط عمومی"
        },
        {
            title: "نشست مجمع عمومی سالانه شرکت طراحی و مهندسی صنایع انرِژی (EIED) با موفقیت برگزار شد",
            date: "1398/03/08",
            owner: "روابط عمومی"
        },
        {
            title: "هرزنامه های اینترنتی (Spam)",
            date: "1398/07/02",
            owner: "اطلاعیه های ICT"
        },
        {
            title: "الزام ثبت درخواست در سیستم Helpdesk",
            date: "1398/04/01",
            owner: "اطلاعیه های ICT"
        },
        {
            title: "اطلاعیه سیستم مکاتبات دیدگاه",
            date: "1398/02/22",
            owner: "اطلاعیه های ICT"
        }

    ],

    PersonnelInformation: [
        {
            personnelCode: "5631",
            image: './assets/images/avatars/5631.jpg',
            name: 'حمیدرضا علویان',
            department: 'بخش فناوری اطلاعات و ارتباطات (ICT) ',
            email: 'alavian-h@eied.com',
            present: true
        },
        {
            personnelCode: "5600",
            image: './assets/images/avatars/5600.jpg',
            name: 'مهسا آدینه',
            department: 'بخش فناوری اطلاعات و ارتباطات (ICT) ',
            email: 'adineh-m@eied.com',
            present: true
        },
        {
            personnelCode: "6529",
            image: './assets/images/avatars/6529.jpg',
            name: 'حمیدرضا حیدری',
            department: 'بخش فناوری اطلاعات و ارتباطات (ICT) ',
            email: 'heidari-ha@eied.com',
            present: true
        },
        {
            personnelCode: "6616",
            image: './assets/images/avatars/6616.jpg',
            name: 'سارا 	امینی سردهائی',
            department: 'بخش فناوری اطلاعات و ارتباطات (ICT) ',
            email: 'amini-s@eied.com',
            present: false
        },
        {
            personnelCode: "3949",
            image: './assets/images/avatars/3949.jpg',
            name: 'وحيده 	بانج شفيعی',
            department: 'بخش فناوری اطلاعات و ارتباطات (ICT) ',
            email: 'banej-v@eied.com',
            present: false
        },
        {
            personnelCode: "3404",
            image: './assets/images/avatars/3404.jpg',
            name: 'محمد حسين 	حيدري',
            department: 'بخش فناوری اطلاعات و ارتباطات (ICT) ',
            email: 'heidaru-h@eied.com',
            present: true
        },
    ],
    Projects:
        [
            {
                id: 1,
                name: "South Pars 20&21",
                group: "EPC"
            },
            {
                id: 2,
                name: "LPG Polishing 20&21",
                group: "EPC"
            },
            {
                id: 3,
                lable: "South Pars Phases 17&18",
                group: "EPC"
            },
            {
                id: 4,
                name: "TGTU Phase 2&3",
                group: "EPC"
            },
            {
                id: 5,
                name: "General",
                group: "EPC"
            },
            {
                id: 6,
                name: "Engineering",
                group: "EPC"
            },
            {
                id: 7,
                name: "Arvandan Project",
                group: "EPC"
            },
            {
                id: 8,
                name: "Ilam HDPE Plant-ILPC",
                group: "EPC"
            },
            {
                id: 9,
                name: "Monitoring-PEDEC,MOP",
                group: "MC"
            },
            {
                id: 10,
                name: "BidBoland II Feed",
                group: "MC"
            },
            {
                id: 11,
                name: "North Six Compressor",
                group: "MC"
            },
            {
                id: 12,
                name: "200 turbo compressor",
                group: "MC"
            },
            {
                id: 13,
                name: "NGL3200",
                group: "MC"
            },
            {
                id: 14,
                name: "KPRSupervision",
                group: "MC"
            },
            {
                id: 15,
                name: "Mahshahr",
                group: "MC"
            }

        ],
    CartableTree: [
        {
            key: '0-0',
            title: 'هما',
            children:
                [
                    {
                        key: '0-0-0',
                        title: 'کارهای جاری'
                    },
                    {
                        key: '0-0-1',
                        title: 'کارهای انجام شده'
                    },
                    {
                        key: '0-0-2',
                        title: 'پیغام'
                    }
                ]
        },
        // {
        //     key: '0-1',
        //     title: 'درخواست ها',
        //     children: [
        //         {
        //             key: '0-1-0',
        //             title: 'منابع انسانی'
        //         },
        //         {
        //             key: '0-1-1',
        //             title: 'اداری'
        //         },
        //         {
        //             key: '0-1-2',
        //             title: 'درخواست کالا و اموال'
        //         },
        //         {
        //             key: '0-1-3',
        //             title: 'آموزش'
        //         }
        //     ]
        // }
    ],
    Request: {
        CurrentTask: [
            { type: "S", requestDate: "1398/08/10", requestType: "عادی", requestStatus: "تحت بررسی", requestDescription: "گواهی اشتغال به کار" },
            { type: "S", requestDate: "1398/08/15", requestType: "عادی", requestStatus: "انجام شده", requestDescription: "درخواست کالا از انبار" },
            { type: "A", requestDate: "1398/01/01", requestType: "عادی", requestStatus: "انجام شده", requestDescription: "نامشخص" },
            { type: "A", requestDate: "1398/02/01", requestType: "عادی", requestStatus: "انجام شده", requestDescription: "نامشخص" },
            { type: "A", requestDate: "1398/03/01", requestType: "عادی", requestStatus: "در حال انجام", requestDescription: "نامشخص" },
            { type: "A", requestDate: "1398/04/01", requestType: "عادی", requestStatus: "تحت بررسی", requestDescription: "نامشخص" },
            { type: "A", requestDate: "1398/05/01", requestType: "عادی", requestStatus: "ارجاع شده", requestDescription: "نامشخص" }
        ],
        DoneTask: [
            { type: "B", requestDate: "1398/01/01", requestType: "عادی", requestStatus: "انجام شده", requestDescription: "نامشخص" },
            { type: "B", requestDate: "1398/02/01", requestType: "عادی", requestStatus: "انجام شده", requestDescription: "نامشخص" }
        ],
        InProgress: [
            { type: "C", requestDate: "1398/03/01", requestType: "عادی", requestStatus: "در حال انجام", requestDescription: "نامشخص" },
            { type: "C", requestDate: "1398/04/01", requestType: "عادی", requestStatus: "تحت بررسی", requestDescription: "نامشخص" },
            { type: "C", requestDate: "1398/05/01", requestType: "عادی", requestStatus: "ارجاع شده", requestDescription: "نامشخص" }
        ]
    },
    Messages: {
        Messages: [
            { date: "1398/01/01", type: "عادی", description: "توضیحات اول پیغام" },
            { date: "1398/01/01", type: "عادی", description: "توضیحات اول پیغام" },
            { date: "1398/02/01", type: "عادی", description: "توضیحات دوم پیغام" },
            { date: "1398/03/01", type: "عادی", description: "توضیحات سوم پیغام" },
            { date: "1398/04/01", type: "عادی", description: "توضیحات چهارم پیغام" },
            { date: "1398/05/01", type: "عادی", description: "توضیحات پنجم پیغام" },
            { date: "1398/06/01", type: "عادی", description: "توضیحات ششم پیغام" },
        ]
    },
    NewProjects: [
        { value: '0', label: 'Select an item ...' },
        {
            type: 'group', name: 'EPC', items: [
                { value: '1', label: 'Hyco' },
                { value: '2', label: 'Ilam SRU' }
            ]
        },
        {
            type: 'group', name: 'MC', items: [
                { value: '3', label: 'Mahshahr 1328' },
                { value: '4', label: 'NGL 3200' }
            ]
        }
    ],
    Diagrams: {
        radar: {
            label: [
                "Hyco",
                "Ilam SRU",
                "Mahshahr 1328",
                "NGL 3200"
            ],
            color: [
                'black',
                'red',
                'orange',
                'yellow'
            ]
        }
    },
    // projectTreeData: [
    //     { key: '0-0', title: 'parent 1', children:
    //       [
    //         { key: '0-0-0', title: 'parent 1-1', children:
    //           [
    //             { key: '0-0-0-0', title: 'parent 1-1-0' },
    //           ],
    //         },
    //         { key: '0-0-1', title: 'parent 1-2', children:
    //             [
    //               { key: '0-0-1-0', title: 'parent 1-2-0', disableCheckbox: true },
    //               { key: '0-0-1-1', title: 'parent 1-2-1' },
    //             ],
    //         },
    //       ],
    //     },
    //   ],
    projectTreeData: [
        {
            key: '00', title: 'Marketing & Proposals', children:
                [
                    { key: '000', title: 'ITBs & Tender Documents' },
                    { key: '001', title: 'Agreements with Partners' },
                    { key: '002', title: 'E-mails' },
                    { key: '003', title: 'Letters' },
                    { key: '004', title: 'MOMs' },
                    { key: '005', title: 'Submitter Proposal' },
                    { key: '006', title: 'Received Proposal' },
                ],
        },
        {
            key: '01', title: 'Contracts, Agreements, Claims & Change orders', children:
                [
                    { key: '010', title: 'Doc.s for the Refrence Plant' },
                    { key: '011', title: 'Contract & Addendums' },
                    { key: '012', title: 'Consortium Agreement & Split of Work' },
                    { key: '013', title: 'Claims & Change of works, Change Log Sheets' },
                ],
            },
            {
            key: '02', title: 'General', children:
                [
                    { key: '020', title: 'Project Structure & Information' },
                    { key: '021', title: 'Project Lessons Learned' },
                    { key: '022', title: 'OTHER' },
                    { key: '023', title: 'Project Management (PM) Documents' },
                    { key: '024', title: 'Project Formats' },
                    { key: '025', title: 'MOMs' },
                    { key: '026', title: 'Correspondences' },
                    { key: '027', title: 'Planning & Project Control' },
                    { key: '028', title: 'Financial' },
                    { key: '029', title: 'QHSE' },
                    { key: '0210', title: 'Certificates' },
                ]
        },
        {
            key: '03', title: 'Engineering', children:
                [
                    { key: '030', title: 'Feasibility Study' },
                    { key: '031', title: 'Conceptual Design' },
                    { key: '032', title: 'Basic' },
                    { key: '033', title: 'Licensor' },
                    { key: '034', title: 'FEED' },
                    { key: '035', title: 'Detail' },
                    { key: '036', title: 'As Built Doc.s' },
                    { key: '037', title: 'Vendor Docs & Data Book' }
                ]
        },
        {
            key: '04', title: 'Procurement', children:
                [
                    { key: '040', title: 'Common Docs' },
                    { key: '041', title: 'TL' },
                    { key: '042', title: 'IN' },
                    { key: '043', title: 'ME' },
                    { key: '044', title: 'HV' },
                    { key: '045', title: 'MA' },
                    { key: '046', title: 'Technical Inspection' },
                    { key: '047', title: 'PR' },
                    { key: '048', title: 'SA' },
                    { key: '049', title: 'PI' },
                    { key: '0410', title: 'CV' },
                    { key: '0411', title: 'EL' }
                ]
        },
        {
            key: '05', title: 'Field Engineering, Construction & Precommissioning', children:
                [
                    { key: '050', title: 'Field Engineering' },
                    { key: '051', title: 'Material Reports' },
                    { key: '052', title: 'Field Planning Reports' },
                    { key: '053', title: 'Field HSE Reports' },
                    { key: '054', title: 'Land Hand Over, Mom, Demob' },
                    { key: '055', title: 'Field QA, QC & Supervision' },
                    { key: '056', title: 'Precommissioning' }
                ]
        },
        {
            key: '06', title: 'Commissioning', children:
                [
                    { key: '060', title: 'Performance Test Certificate' },
                    { key: '061', title: 'Provisional Acceptance MOMs' },
                    { key: '062', title: 'Final Acceptance MOMs' },
                ]
        },
        {
            key: '07', title: 'System Reports', children:
                [
                    { key: '070', title: 'Engineering & Licensor' }
                ]
        },

    ],
    News: [
        {
            title: "روابط عمومی",
            body: "EIED در پنجمین کـــنگره راهبردی و نـمایشگاه نـفت و نـیرو",
            image: './assets/images/news/news1.jpg'
        },
        {
            title: "روابط عمومی",
            body: "پیام مدیریت محترم عامل به مناسبت بیست و سومین سالگرد تاسیس شرکت طراحی و مهندسی صنایع انرژی",
            image: './assets/images/news/news2.jpg'
        },

    ],
    ToDoList: [
        { key: 1, title: "ثبت تایم شیت" },
        { key: 2, title: "جلسه هفتگی واحد ساعت 14" },
        { key: 3, title: "ارسال مدارک بیمه به مسول بیمه" },
        { key: 4, title: "ثبت غذای هفتگی" },
        { key: 5, title: "وقت دکتر 12:30" }
    ],
    CoordinatorDashboardReasons: [
        { value: 0, label: "Reason 1" },
        { value: 1, label: "Reason 2" },
        { value: 2, label: "Reason 3" },
        { value: 3, label: "Reason 4" },
        { value: 4, label: "Reason 5" }
    ],
    CoordinatorDashboard: [
        { id: 1, taskId: "1445-ME100-0001-1", taskDescription: "Preparing Vessel Mechanical Datasheets for D-4001-First", owner: "Me", status: { value: 1, label: "Ready" }, holdReason: { value: 1, label: "Reason 1" }, taskSection: "Presure Vessel 1", dueDate: "P:25/12/2019 F1:30/12/2019", remainDays: "5", action: "Done" },
        { id: 2, taskId: "1456-ME105-0010-4", taskDescription: "Vessel Preparing Mechanical Datasheets for A-6754-Second", owner: "You", status: { value: 2, label: "Hold" }, holdReason: { ivalued: 2, label: "Reason 3" }, taskSection: "Presure Vessel 2", dueDate: "P:25/12/2019 F1:30/12/2019", remainDays: "8", action: "In Progress" },
        { id: 3, taskId: "1474-ME110-0850-8", taskDescription: "Mechanical Preparing Vessel  Datasheets for F-6985-Third", owner: "her", status: { value: 2, label: "Hold" }, holdReason: { value: 4, label: "Reason 5" }, taskSection: "Presure Vessel 3", dueDate: "P:25/12/2019 F1:30/12/2019", remainDays: "13", action: "Completed" },
    ],
    CoordinatorDashboardStatus: [
        { value: 0, label: "Not Set ..." },
        { value: 1, label: "Ready" },
        { value: 2, label: "Hold" }
    ],
    CarouselItems: [
        {
            type: "image", items:
                [
                    {
                        src: "assets/images/Slider/Slider1.jpg",
                        altText: 'Slide 1',
                        caption: 'Slide 1'
                    },
                    {
                        src: "assets/images/Slider/Slider2.jpg",
                        altText: 'Slide 2',
                        caption: 'Slide 2'
                    },
                    {
                        src: "assets/images/Slider/Slider3.jpg",
                        altText: 'Slide 3',
                        caption: 'Slide 3'
                    },
                ]
        },
        {
            type: "movie", items:
                [
                    {
                        src: "assets/movies/movie_1.mp4"
                    },
                    {
                        src: "assets/movies/movie_2.mp4"
                    }
                ]
        },

    ],
    Activities: [
        { id: 314700, code: "KP-10-00-DD-PC-PRC-0002", description: "Invoicing Procedure" },
        { id: 314701, code: "KP-10-00-DD-PC-PRC-0003", description: "Engineering Documents Numbering Procedure" },
        { id: 314702, code: "KP-10-00-DD-PC-PRC-0003", description: "Material Requisition For Brazed Aluminum Plate Fin Heat Exchangers" },
        { id: 314703, code: "KP-10-00-DD-PC-PRC-0004", description: "General Inspection And Test Procedure" },
        { id: 314704, code: "KP-10-00-DD-PC-PRC-0005", description: "Material Requisition For Sale Gas Compressors And Drivers" },
        { id: 314705, code: "KP-10-00-DD-PC-PRC-0006", description: "Material Requisition For Feed Gas Expander/Sales Gas Booster Compressor" },
        { id: 314706, code: "KP-10-00-DD-PC-PRC-0007", description: "Mechanical Data Sheet For Treater Regenration Gas Compressor" },
        { id: 314707, code: "KP-10-00-DD-PC-PRC-0008", description: "General Specification For Expander- Compresors" },
        { id: 314708, code: "KP-10-00-DD-PC-PRC-0009", description: "Material Requisition for Refrigerant Compressors and Drivers" },
        { id: 314709, code: "KP-10-00-DD-PC-PRC-0010", description: "Inquiry Packege For Treater Regenration Gas Compressor" },
        { id: 314709, code: "KP-10-00-DD-PC-PRC-0011", description: "Detail Design and Procurement Services Document List" },
        { id: 314710, code: "KP-10-00-DD-PC-PRC-0012", description: "Scheduling & Reporting Procedure" },
        { id: 314711, code: "KP-10-00-DD-PC-PRC-0013", description: "Classification List" },
        { id: 314712, code: "KP-10-00-DD-PC-PRC-0014", description: "General Terms And Conditions of Purchasing" },
        { id: 314713, code: "KP-10-00-DD-PC-PRC-0015", description: "Specification for Gaskets" },
        { id: 314714, code: "KP-10-00-DD-PC-PRC-0016", description: "Standard Details Pipe Bedding" },
        { id: 314715, code: "KP-10-00-DD-PC-PRC-0017", description: "Building Functional Specification" }
    ],
    Documents: [
        { id: 314700, description: "Underground Composite Plan for Area 1" },
        { id: 314701, description: "Underground Composite Plan for Area 2" },
        { id: 314702, description: "Underground Composite Plan for Area 3" },
        { id: 314703, description: "Underground Composite Plan for Area 4" },
        { id: 314704, description: "Underground Composite Plan for Area 5" },
        { id: 314705, description: "Underground Composite Plan for Area 6" },
        { id: 314706, description: "Underground Composite Plan for Area 7" },
        { id: 314707, description: "Underground Composite Plan for Area 8" },
        { id: 314708, description: "Underground Composite Plan for Area 9" },
        { id: 314709, description: "Underground Composite Plan for Area 10" },
        { id: 314709, description: "Underground Composite Plan for Area 11" },
        { id: 314710, description: "Underground Composite Plan for Area 12" },
        { id: 314711, description: "Underground Composite Plan for Area 13" },
        { id: 314712, description: "Underground Composite Plan for Area 14" },
        { id: 314713, description: "Underground Composite Plan for Area 15" },
        { id: 314714, description: "Underground Composite Plan for Area 16" },
        { id: 314715, description: "Underground Composite Plan for Area 17" }
    ],
    Types: [
        { id: 1, description: "Project Activity" },
        { id: 2, description: "Custom Activity for Project" },
        { id: 3, description: "Discipline Custom Activity" }
    ],
    Owners: [
        { id: "D324801D-061B-473F-B139-4BFC99B48E7A", generalId: 1669, fullName: "Minaee, Narges" },
        { id: "EE4B13F5-6A0F-484F-9248-0A333313E082", generalId: 307, fullName: "Heidari, Hamidreza" },
        { id: "81293C65-7528-4DAD-8E86-F98C9F5D337D", generalId: 2467, fullName: "Kazerani, Mehdi" },
        { id: "E95B92AF-C22F-4B93-84EF-2B21E34037F5", generalId: 2044, fullName: "Alavian, Hamidreza" },
        { id: "9F1BC3B8-64D3-4D84-9C0C-3AF0F8080CC3", generalId: 963, fullName: "Shahsavan, Mozhgan" },
        { id: "79680E3C-E330-4E96-B374-F11986DBEFCF", generalId: 2013, fullName: "Adineh, Mahsa" }
    ],
    DailyActivity: [
        {
            id: 1,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                8, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                11, 0, 0),
            title: "تیتر تستی اول روزانه",
            description: "توضیحات اضافه اول روزانه",
            color: "#F8C471"
        },
        {
            id: 2,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                10, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                14, 0, 0),
            title: "تیتر تستی دوم روزانه",
            description: "توضیحات اضافه دوم روزانه ",
            color: "#5499C7"
        },
        {
            id: 3,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                16, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                17, 0, 0),
            title: "تیتر تستی سوم  روزانه",
            description: "توضیحات اضافه  سوم  روزانه",
            color: "#DC7633"
        },
        {
            id: 4,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                17, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                18, 0, 0),
            title: "تیتر تستی چهارم  روزانه",
            description: "توضیحات اضافه  چهارم  روزانه",
            color: "#DC7633"
        },
        {
            id: 5,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                10, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                13, 0, 0),
            title: "تیتر تستی پنجم  روزانه",
            description: "توضیحات اضافه  پنجم  روزانه",
            color: "#5499C7"
        },
        {
            id: 5,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                8, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate(),
                18, 0, 0),
            title: "تیتر تستی ششم  روزانه",
            description: "توضیحات اضافه  ششم  روزانه",
            color: "#F8C471"
        }
    ],
    DailyActivityYesterday: [
        {
            id: 1,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                8, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                11, 0, 0, 0),
            title: "تیتر تستی اول روزانه دیروز",
            description: "توضیحات اضافه اول روزانه دیروز",
            color: "#F8C471"
        },
        {
            id: 2,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                10, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                14, 0, 0, 0),
            title: "تیتر تستی دوم روزانه دیروز",
            description: "توضیحات اضافه دوم روزانه دیروز ",
            color: "#5499C7"
        },
        {
            id: 3,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                16, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                17, 0, 0, 0),
            title: "تیتر تستی سوم  روزانه دیروز",
            description: "توضیحات اضافه  سوم  روزانه دیروز",
            color: "#DC7633"
        },
        {
            id: 4,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                17, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                18, 0, 0, 0),
            title: "تیتر تستی چهارم  روزانه دیروز",
            description: "توضیحات اضافه  چهارم  روزانه دیروز",
            color: "#DC7633"
        },
        {
            id: 5,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                10, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                13, 0, 0, 0),
            title: "تیتر تستی پنجم  روزانه دیروز",
            description: "توضیحات اضافه  پنجم  روزانه دیروز",
            color: "#5499C7"
        },
        {
            id: 5,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                8, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1,
                18, 0, 0, 0),
            title: "تیتر تستی ششم  روزانه دیروز",
            description: "توضیحات اضافه  ششم  روزانه دیروز",
            color: "#F8C471"
        }
    ],
    DailyActivityTomorrow: [
        {
            id: 1,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                8, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                11, 0, 0, 0),
            title: "تیتر تستی اول روزانه فردا",
            description: "توضیحات اضافه اول روزانه فردا",
            color: "#F8C471"
        },
        {
            id: 2,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                10, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                14, 0, 0, 0),
            title: "تیتر تستی دوم روزانه فردا",
            description: "توضیحات اضافه دوم روزانه فردا ",
            color: "#5499C7"
        },
        {
            id: 3,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                16, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                17, 0, 0, 0),
            title: "تیتر تستی سوم  روزانه فردا",
            description: "توضیحات اضافه  سوم  روزانه فردا",
            color: "#DC7633"
        },
        {
            id: 4,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                17, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                18, 0, 0, 0),
            title: "تیتر تستی چهارم  روزانه فردا",
            description: "توضیحات اضافه  چهارم  روزانه فردا",
            color: "#DC7633"
        },
        {
            id: 5,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                10, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                13, 0, 0, 0),
            title: "تیتر تستی پنجم  روزانه فردا",
            description: " فرداتوضیحات اضافه  پنجم  روزانه",
            color: "#5499C7"
        },
        {
            id: 5,
            start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                8, 0, 0, 0),
            end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1,
                18, 0, 0, 0),
            title: "تیتر تستی ششم  روزانه فردا",
            description: "توضیحات اضافه  ششم  روزانه فردا",
            color: "#F8C471"
        }
    ],
    WeeklyActivity: [
        {
            id: 1,
            start: new Date("2020/08/15 08:00:00.000"),
            end: new Date("2020/08/15 11:00:00.000"),
            title: "تیتر تستی اول هفتگی",
            description: "توضیحات اضافه اول  هفتگی",
            color: "#F8C471"
        },
        {
            id: 2,
            start: new Date("2020/08/15 10:00:00.000"),
            end: new Date("2020/08/15 14:00:00.000"),
            title: "تیتر تستی دوم  هفتگی",
            description: "دوم توضیحات دوم  هفتگی ",
            color: "#5499C7"
        },
        {
            id: 3,
            start: new Date("2020/08/16 14:00:00.000"),
            end: new Date("2020/08/16 17:00:00.000"),
            title: "تیتر تستی سوم  هفتگی",
            description: "توضیحات اضافه  سوم  هفتگی",
            color: "#DC7633"
        },
        {
            id: 4,
            start: new Date("2020/08/16 16:00:00.000"),
            end: new Date("2020/08/16 18:00:00.000"),
            title: "تیتر تستی چهارم  هفتگی",
            description: "توضیحات اضافه  چهارم  هفتگی",
            color: "#DC7633"
        },
        {
            id: 5,
            start: new Date("2020/08/17 10:00:00.000"),
            end: new Date("2020/08/17 13:00:00.000"),
            title: "تیتر تستی پنجم  هفتگی",
            description: "توضیحات اضافه  پنجم  هفتگی",
            color: "#5499C7"
        },
        {
            id: 6,
            start: new Date("2020/08/17 08:00:00.000"),
            end: new Date("2020/08/17 18:00:00.000"),
            title: "تیتر تستی ششم  هفتگی",
            description: "توضیحات اضافه  ششم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 7,
            start: new Date("2020/08/18 11:00:00.000"),
            end: new Date("2020/08/18 14:00:00.000"),
            title: "تیتر تستی هفتم  هفتگی",
            description: "توضیحات اضافه  هفتم",
            color: "#F8C471"
        },
        {
            id: 8,
            start: new Date("2020/08/18 12:00:00.000"),
            end: new Date("2020/08/18 15:00:00.000"),
            title: "تیتر تستی هشتم  هفتگی",
            description: "توضیحات اضافه  هشتم هفتگی",
            color: "#5499C7"
        },
        {
            id: 9,
            start: new Date("2020/08/19 11:00:00.000"),
            end: new Date("2020/08/19 16:00:00.000"),
            title: "تیتر تستی نهم  هفتگی",
            description: "توضیحات اضافه  نهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 10,
            start: new Date("2020/08/19 16:00:00.000"),
            end: new Date("2020/08/19 18:00:00.000"),
            title: "تیتر تستی دهم  هفتگی",
            description: "توضیحات اضافه  دهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 11,
            start: new Date("2020/08/20 11:00:00.000"),
            end: new Date("2020/08/20 15:00:00.000"),
            title: "تیتر تستی یازدهم  هفتگی",
            description: "توضیحات اضافه  یازدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 12,
            start: new Date("2020/08/20 08:00:00.000"),
            end: new Date("2020/08/20 17:00:00.000"),
            title: "تیتر تستی دوازدهم  هفتگی",
            description: "توضیحات اضافه  دوازدهم  هفتگی",
            color: "#F8C471"
        }
    ],
    MonthlyActivity: [
        {
            id: 1,
            start: new Date("2020/07/22 08:00:00.000"),
            end: new Date("2020/07/22 12:00:00.000"),
            title: "تیتر تستی اول هفتگی",
            description: "توضیحات اضافه اول  هفتگی",
            color: "#F8C471"
        },
        {
            id: 2,
            start: new Date("2020/07/22 11:00:00.000"),
            end: new Date("2020/07/22 16:00:00.000"),
            title: "تیتر تستی دوم  هفتگی",
            description: "دوم توضیحات دوم  هفتگی ",
            color: "#5499C7"
        },
        {
            id: 3,
            start: new Date("2020/07/24 15:00:00.000"),
            end: new Date("2020/07/24 18:00:00.000"),
            title: "تیتر تستی سوم  هفتگی",
            description: "توضیحات اضافه  سوم  هفتگی",
            color: "#DC7633"
        },
        {
            id: 4,
            start: new Date("2020/07/24 09:00:00.000"),
            end: new Date("2020/07/24 11:00:00.000"),
            title: "تیتر تستی چهارم  هفتگی",
            description: "توضیحات اضافه  چهارم  هفتگی",
            color: "#DC7633"
        },
        {
            id: 5,
            start: new Date("2020/07/29 10:00:00.000"),
            end: new Date("2020/07/29 13:00:00.000"),
            title: "تیتر تستی پنجم  هفتگی",
            description: "توضیحات اضافه  پنجم  هفتگی",
            color: "#5499C7"
        },
        {
            id: 6,
            start: new Date("2020/07/29 14:00:00.000"),
            end: new Date("2020/07/29 18:00:00.000"),
            title: "تیتر تستی ششم  هفتگی",
            description: "توضیحات اضافه  ششم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 7,
            start: new Date("2020/08/02 07:00:00.000"),
            end: new Date("2020/08/02 13:00:00.000"),
            title: "تیتر تستی هفتم  هفتگی",
            description: "توضیحات اضافه  هفتم",
            color: "#F8C471"
        },
        {
            id: 8,
            start: new Date("2020/08/02 13:00:00.000"),
            end: new Date("2020/08/02 17:00:00.000"),
            title: "تیتر تستی هشتم  هفتگی",
            description: "توضیحات اضافه  هشتم هفتگی",
            color: "#5499C7"
        },
        {
            id: 9,
            start: new Date("2020/08/04 09:00:00.000"),
            end: new Date("2020/08/04 12:00:00.000"),
            title: "تیتر تستی نهم  هفتگی",
            description: "توضیحات اضافه  نهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 10,
            start: new Date("2020/08/04 13:00:00.000"),
            end: new Date("2020/08/04 18:00:00.000"),
            title: "تیتر تستی دهم  هفتگی",
            description: "توضیحات اضافه  دهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 11,
            start: new Date("2020/08/08 11:00:00.000"),
            end: new Date("2020/08/08 15:00:00.000"),
            title: "تیتر تستی یازدهم  هفتگی",
            description: "توضیحات اضافه  یازدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 12,
            start: new Date("2020/08/08 08:00:00.000"),
            end: new Date("2020/08/08 17:00:00.000"),
            title: "تیتر تستی دوازدهم  هفتگی",
            description: "توضیحات اضافه  دوازدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 13,
            start: new Date("2020/08/13 11:00:00.000"),
            end: new Date("2020/08/13 13:00:00.000"),
            title: "تیتر تستی سیزدهم هفتگی",
            description: "توضیحات اضافه  سیزدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 14,
            start: new Date("2020/08/13 14:00:00.000"),
            end: new Date("2020/08/13 16:00:00.000"),
            title: "تیتر تستی چهاردهم  هفتگی",
            description: "توضیحات اضافه  چهاردهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 15,
            start: new Date("2020/08/15 08:00:00.000"),
            end: new Date("2020/08/15 12:00:00.000"),
            title: "تیتر تستی پانزدهم  هفتگی",
            description: "توضیحات اضافه  پانزدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 16,
            start: new Date("2020/08/15 02:00:00.000"),
            end: new Date("2020/08/15 17:00:00.000"),
            title: "تیتر تستی شانزدهم  هفتگی",
            description: "توضیحات اضافه  شانزدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 17,
            start: new Date("2020/08/19 11:00:00.000"),
            end: new Date("2020/08/19 13:00:00.000"),
            title: "تیتر تستی هفدهم  هفتگی",
            description: "توضیحات اضافه  هفدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 18,
            start: new Date("2020/08/19 11:00:00.000"),
            end: new Date("2020/08/19 15:00:00.000"),
            title: "تیتر تستی هجدهم  هفتگی",
            description: "توضیحات اضافه  هجدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 19,
            start: new Date("2020/08/21 08:00:00.000"),
            end: new Date("2020/08/21 14:00:00.000"),
            title: "تیتر تستی نوزدهم  هفتگی",
            description: "توضیحات اضافه  نوزدهم  هفتگی",
            color: "#F8C471"
        },
        {
            id: 20,
            start: new Date("2020/08/21 10:00:00.000"),
            end: new Date("2020/08/21 16:00:00.000"),
            title: "تیتر تستی بیستم  هفتگی",
            description: "توضیحات اضافه  بیستم  هفتگی",
            color: "#F8C471"
        }
    ]


}




